import React from 'react';
import { Pie } from '@ant-design/plots';
import { StatusPoint } from 'store/ducks/Global/types';
// TODO - still need to work , this is just a sample
/* ---------------- MOCK STATUS DATA ---------------- */

const generateStatusData = (labels: string[]): StatusPoint[] =>
  labels.map((label) => ({
    type: label,
    value: Math.floor(Math.random() * 100) + 20
  }));

const solutionStatus = generateStatusData([
  'Successful',
  'In Progress',
  'Failed',
  'Not Started'
]);

const evidenceStatus = generateStatusData([
  'Available',
  'Missing',
  'Under Review',
  'Rejected'
]);

const gapStatus = generateStatusData([
  'Open',
  'In Remediation',
  'Closed',
  'Accepted Risk'
]);

const auditStatus = generateStatusData([
  'Resolved',
  'Open Finding',
  'In Progress',
  'Overdue'
]);

const controlStatus = generateStatusData([
  'Effective',
  'Ineffective',
  'Partially Effective',
  'Not Tested'
]);

/* ---------------- PIE CONFIG BUILDER ---------------- */

const createPieConfig = (data: StatusPoint[]) => {
  const total = data.reduce((sum, d) => sum + d.value, 0);

  return {
    data,
    angleField: 'value',
    colorField: 'type',
    height: 260,

    label: {
      text: (datum: any) => {
        const percent = ((datum.value / total) * 100).toFixed(0);
        return `${percent}%`;
      },
      style: {
        fontWeight: 'bold',
        fontSize: 12
      }
    },

    tooltip: {
      formatter: (datum: any) => {
        const percent = ((datum.value / total) * 100).toFixed(1);
        return {
          name: datum.type,
          value: `${percent}% (${datum.value})`
        };
      }
    },

    legend: {
      position: 'bottom'
    },

    interaction: {
      elementHighlight: true
    }
  };
};

/* ---------------- UI ---------------- */

const pageStyle: React.CSSProperties = {
  padding: 28,
  minHeight: '100vh',
  background: '#f4f7fb'
};

const gridRow: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
  gap: 20,
  marginBottom: 20
};

const Card = ({ title, children }: any) => (
  <div
    style={{
      background: '#ffffff',
      borderRadius: 16,
      padding: 18,
      boxShadow: '0 6px 18px rgba(0,0,0,0.06)',
      transition: 'all 0.2s ease',
      border: '1px solid #eef1f6'
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = 'translateY(-3px)';
      e.currentTarget.style.boxShadow = '0 10px 25px rgba(0,0,0,0.08)';
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = 'translateY(0px)';
      e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.06)';
    }}
  >
    <div
      style={{
        fontSize: 15,
        marginBottom: 14,
        color: '#1f2937',
        fontWeight: 600,
        letterSpacing: 0.3
      }}
    >
      {title}
    </div>

    <div style={{ paddingTop: 6 }}>{children}</div>
  </div>
);
/* ---------------- DASHBOARD ---------------- */

const DashboardCompliance: React.FC = () => {
  return (
    <div style={pageStyle}>
      <h2
        style={{
          marginBottom: 20,
          fontWeight: 600,
          color: '#111827'
        }}
      >
        Audit & Compliance Overview
      </h2>
      <div style={gridRow}>
        <Card title='Solution Status'>
          <Pie {...createPieConfig(solutionStatus)} />
        </Card>

        <Card title='Evidence Status'>
          <Pie {...createPieConfig(evidenceStatus)} />
        </Card>

        <Card title='Gaps Status'>
          <Pie {...createPieConfig(gapStatus)} />
        </Card>
      </div>

      <div style={gridRow}>
        <Card title='Audit Findings Status'>
          <Pie {...createPieConfig(auditStatus)} />
        </Card>

        <Card title='Control Effectiveness'>
          <Pie {...createPieConfig(controlStatus)} />
        </Card>
      </div>
    </div>
  );
};

export default DashboardCompliance;
